/**
 * StatusPill tones — colour intent only. Each tone maps to a tinted
 * background + foreground pair drawn from the M3 palette (success / caution /
 * error / primary), with `neutral` falling back to the surface-container
 * stack for the "draft / unknown" case.
 */
export const STATUS_PILL_TONE_NEUTRAL = 'neutral';
export const STATUS_PILL_TONE_SUCCESS = 'success';
export const STATUS_PILL_TONE_CAUTION = 'caution';
export const STATUS_PILL_TONE_ERROR = 'error';
export const STATUS_PILL_TONE_INFO = 'info';

export type StatusPillTone =
  | typeof STATUS_PILL_TONE_NEUTRAL
  | typeof STATUS_PILL_TONE_SUCCESS
  | typeof STATUS_PILL_TONE_CAUTION
  | typeof STATUS_PILL_TONE_ERROR
  | typeof STATUS_PILL_TONE_INFO;
